import { IconCheck, IconMinus, IconX } from '@tabler/icons-react';

interface IXCheckOrMinusIcon {
  displayX: boolean;
  displayCheck: boolean;
  displayMinus: boolean;
  ariaLabelX: string;
  ariaLabelCheck: string;
  ariaLabelMinus: string;
}

export const XCheckOrMinusIcon = ({
  displayX,
  displayCheck,
  displayMinus,
  ariaLabelX,
  ariaLabelCheck,
  ariaLabelMinus,
}: IXCheckOrMinusIcon) =>
  displayX ? (
    <IconX className="text-accent-red" stroke={1} size={24} role="img" aria-label={ariaLabelX} />
  ) : displayCheck ? (
    <IconCheck stroke={1} size={24} role="img" aria-label={ariaLabelCheck} />
  ) : displayMinus ? (
    <IconMinus stroke={1} size={24} role="img" aria-label={ariaLabelMinus} />
  ) : (
    <></>
  );

XCheckOrMinusIcon.displayName = 'XCheckOrMinusIcon';
